import Seo from "@/components/Seo";
import { SiteButton } from "@/components/brand/SiteButton";
import { Container, Section } from "@/components/layout/Section";
import { ROUTE_SEO } from "@/config/seoData";

const phaseMap = {
  "/services": 5,
  "/work": 8,
  "/about": 8,
  "/resources": 8,
  "/contact": 6,
};

const PlaceholderPage = ({ title, description, noindex = false, canonicalPath }) => {
  const phase = phaseMap[window.location.pathname.startsWith("/services") ? "/services" : window.location.pathname];
  return (
    <>
      <Seo title={title} description={description} noindex={noindex} canonicalPath={canonicalPath} />
      <Section testid="placeholder-page" className="flex min-h-[70vh] items-center pt-32">
        <Container className="max-w-2xl space-y-6">
          <p className="eyebrow">{phase ? `Arriving in Phase ${phase}` : "Coming soon"}</p>
          <h1 className="font-display text-3xl font-bold tracking-tight text-brand-snow sm:text-4xl lg:text-5xl">
            {title}
          </h1>
          <p className="text-base leading-relaxed text-brand-mist">{description}</p>
          <div className="flex flex-wrap gap-4 pt-2">
            <SiteButton to="/" variant="outline" testid="placeholder-back-home">
              Back to home
            </SiteButton>
            <SiteButton to="/contact" testid="placeholder-cta-contact">
              Talk to us
            </SiteButton>
          </div>
        </Container>
      </Section>
    </>
  );
};

export const PlaceholderServiceDetail = () => (
  <PlaceholderPage
    title="Service detail"
    description="The full service page — overview, deliverables, process, FAQs and enquiry CTA — is generated from the CMS template in Phase 5."
  />
);

export const ServicesPlaceholder = () => (
  <PlaceholderPage
    title="Services"
    description="Five capability categories, twenty-nine services, each with its own dedicated page — built on the CMS-driven template in the upcoming phases."
  />
);

export const WorkPlaceholder = () => (
  <PlaceholderPage
    title="Work"
    description="A showcase of concept case studies and exploratory architecture — clearly labelled demonstrations of craft, never fabricated client work."
  />
);

export const AboutPlaceholder = () => (
  <PlaceholderPage
    title="About A2Z Rankings"
    description="Who we are, how we work, and why Australian businesses partner with an international technology team."
  />
);

export const ResourcesPlaceholder = () => (
  <PlaceholderPage
    title="Resources"
    description="Guides, insights and playbooks on software delivery, AI adoption and digital growth — publishing soon."
  />
);

export const ContactPlaceholder = () => (
  <PlaceholderPage
    title="Contact"
    description="The enquiry system — validated form, email delivery to info@a2zrankings.com and database records — ships in Phase 6."
  />
);

export const NotFound = () => (
  <PlaceholderPage
    title={ROUTE_SEO.notFound.title}
    description={ROUTE_SEO.notFound.description}
    noindex
  />
);

export default PlaceholderPage;
